import APIIPAddressSettingMessage from '@console/components/project/APIIPAddressSettingMessage';
import type { AppState } from '@console/reducers';
import { getApiConfidentialInformation } from '@console/selectors/projectDetail/confidentialInformation';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  apiConfidentialInformation: getApiConfidentialInformation(state)
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(APIIPAddressSettingMessage);
